module.exports = __webpack_public_path__ + "static/bear@2x-2f5c004dcd7f3e767e8b7dce68500c30.png";